import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';

import { ExperienceEditSectionKeys } from './experience-edit-util';

const { COMPANY_DETAILS, WORK_DETAILS, FOCUS_AREAS, SKILLS } =
  ExperienceEditSectionKeys;

export type ExperienceSectionStateType = {
  [COMPANY_DETAILS]: boolean;
  [WORK_DETAILS]: boolean;
  [FOCUS_AREAS]: boolean;
  [SKILLS]: boolean;
};

const initialExperienceSectionState: ExperienceSectionStateType = {
  [COMPANY_DETAILS]: false,
  [WORK_DETAILS]: false,
  [FOCUS_AREAS]: false,
  [SKILLS]: false,
};

export type ExperienceEditContextType = {
  accordionState: ExperienceSectionStateType;
  setAccordionState: Dispatch<SetStateAction<ExperienceSectionStateType>>;
  dirtyFormState: ExperienceSectionStateType;
  setDirtyFormState: Dispatch<SetStateAction<ExperienceSectionStateType>>;
};

export const ExperienceEditContext = createContext<ExperienceEditContextType>({
  accordionState: initialExperienceSectionState,
  setAccordionState: () => null,
  dirtyFormState: initialExperienceSectionState,
  setDirtyFormState: () => null,
});
